<template>
  <div
      class="history-query-left-nav"
    >
      <PtMasterNav :service="service">
      </PtMasterNav>
  </div>
</template>

<script>
import { MasterNav as PtMasterNav } from 'patsnap-biz';
import { mapActions } from 'vuex';
import '@patsnap-ui/icon/assets/solid/ArrowDown.svg';
import '@patsnap-ui/icon/assets/solid/ArrowUp.svg';
import '@patsnap-ui/icon/assets/solid/Analytics.svg';
import '@patsnap-ui/icon/assets/solid/LoginHistory.svg';
import '@patsnap-ui/icon/assets/solid/CoreProductsDiscovery.svg';
import '@patsnap-ui/icon/assets/solid/CoreProductsChemical.svg';
import 'library-@/assets/icon/products/cas.svg';
import 'library-@/assets/icon/products/eurekaInsights.svg';
import { RavenInsertMeta } from 'library-@/services/sentry';
import getBrowser from 'library-@/utils/browser';
import { get, filter } from 'lodash';
import { HISTORY_PERMISSIONS_MAP } from '@/constants';

const isIE = (getBrowser() || '').indexOf('IE') !== -1;
export default {
    components: {
        PtMasterNav
    },
    data() {
        const service = new PtMasterNav.NavService();
        const self = this;
        service.$t = function (str) {
            return self.$t(str);
        };
        const permission = get(window, 'zPREFACE.history_permission');
        const showEurekaInsights = permission?.eureka_insights && !permission?.discovery
        let partitions = [
            { key: 'analytics', label: 'history.analytics_history', icon: 'SolidAnalytics', url: '/analytics/0/1' },
            { key: 'discovery', label: showEurekaInsights ? 'history.eureka_insights_history' : 'history.discovery_history', icon: showEurekaInsights ? 'ProductsEurekaInsights' : 'SolidCoreProductsDiscovery', url: '/discovery/0/1' },
            { key: 'chemical', label: 'history.chemical_history', icon: 'SolidCoreProductsChemical', url: '/chemical/0/1' },
            { key: 'cas', label: 'history.cas_history', icon: 'ProductsCas', url: '/cas' },
            'patsnap', // 分隔符
            { key: 'login', label: 'history.login_history', icon: 'SolidLoginHistory', url: '/login/0/1' },
        ];
        partitions = filter(partitions, (item) => {
            if (item.key === 'login' || !item.key) {
                return true;
            }

            if(item.key === 'discovery'){
                return permission.discovery || permission.eureka_insights
            }

            return permission[HISTORY_PERMISSIONS_MAP[item.key]];
        });
        service.partitions = partitions;
        service.onClickedLinkHook = function (key, o) {
            this.currentActiveKey = key;
            RavenInsertMeta('History', 'Toggle History Product', {
                Product: this.currentActiveKey
            });
            self.updateHistorySelectedList([]);
            self.$router.push(o.url);
        };
        service.toggleWideHook = function () {
            self.handleResize();
        };
        return {
            service
        };
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                // TODO 同时兼容普通路由和微前端路由，普通路由使用params微前端使用meta传递参数，后续都改为微前端
                // TODO 同时兼容普通路由和微前端路由，普通路由使用params微前端使用meta传递参数，后续都改为微前端
                // TODO 同时兼容普通路由和微前端路由，普通路由使用params微前端使用meta传递参数，后续都改为微前端
                this.service.currentActiveKey = get(this.$route, 'params.type') || get(this.$route, 'meta.type');
            }
        }
    },
    methods: {
        ...mapActions(['updateHistorySelectedList']),
        /* 左侧展开收起手动触发window.resize,multiWrapper组件需要监听 */
        handleResize() {
            if (isIE) {
                var ev = document.createEvent('Event');
                ev.initEvent('resize', true, true);
                window.dispatchEvent(ev);
            } else {
                let myEvent = new Event('resize');
                window.dispatchEvent(myEvent);
            }
        }
    }
};
</script>

<style lang="scss">
.history-query-left-nav {
  height: auto;
  background: #fff;
  box-shadow:  0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 6px 0px rgba(0, 0, 0, 0.08);
  .master_nav__label {
    margin: 0;
  }
  .master_nav-item__wrap {
        svg[icon*="SolidCoreProductsDiscovery"],
        svg[icon*="ProductsEurekaInsights"] {
            font-size: 19px;
        }
    }
}
</style>
